import React, {Component} from 'react';
import {Input, InputGroupAddon} from 'reactstrap';
import _ from 'underscore';

export class InputRow extends Component {

    render() {
        const props = this.props,
            value = props.value || '',
            {line, rows} = props,
            {property_name} = line;
        let append_props = {};

        if (line.type === 'textarea')
            append_props.rows = rows;

        return <InputGroupAddon
            key={1}
            className="w-100"
            addonType="prepend"
        >
            <Input {...append_props}
                   type={line.type}
                   multiple={!!line.multiple}
                   value={value}
                   onChange={
                       (e) => {
                           const value = line.type === 'select' && !!line.multiple
                               ? _.map(_.filter(e.target.options, (option) => option.selected),
                                   (option) => option.value
                               )
                               : e.target.value;
                           props.onChangeSettingsByNameValue(property_name, value)
                       }
                   }
            >
                {props.children}
            </Input>
        </InputGroupAddon>;
    }
}